import { useEffect, useState } from 'react';
import { fetchMe, getCurrentUserInfo } from '../services/authService';

/**
 * The signed-in user's identity and role. Token claims resolve first (admin-ness,
 * username); the API's /me then adds account, role and customer number.
 * canView/canEditCustomers derive from the role ladder: admin and supervisor
 * everywhere in scope, manager within their number, employee read-only with no
 * Customers page.
 */
export default function useCurrentUser() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const token = await getCurrentUserInfo();
      const me = token ? await fetchMe() : null;
      if (cancelled) return;
      const merged = token ? { ...token, ...(me || {}) } : null;
      if (merged) {
        const editorRole = merged.role === 'supervisor' || merged.role === 'manager';
        merged.canViewCustomers = merged.isAdmin || editorRole;
        merged.canEditCustomers = merged.isAdmin || editorRole;
      }
      setUser(merged);
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { user, loading, isAdmin: !!user?.isAdmin };
}
